<template>
  <the-new-header></the-new-header>

  <div class="home-section">
    <home-banner></home-banner>

    <div class="columns">
      <div class="cl1" :style="{ order: getHorizontalData[0]}">
        <home-infomation></home-infomation>
      </div>

      <div class="cl2" :style="{ order: getHorizontalData[1]}">
        <top-column-slider></top-column-slider>
        <div class="sticky-cl">
          <bottom-column-slider></bottom-column-slider>
          <div style="margin-bottom: 80px;">
            <!-- <img @contextmenu.prevent :src="cacheBuster('/TheMedia/Side Banner-989baedf-beee-4d30-81f0-af252bc88e55.jpg')"> -->
            <img @contextmenu.prevent :src="cacheBuster(getBannerByName)">
          </div>
        </div>
      </div>
    </div>
    <customer-slider></customer-slider>
  </div>

  <the-footer></the-footer>
</template>

<script>
import HomeBanner from '@/components/home-page/HomeBanner.vue'
import HomeInfomation from '@/components/home-layout/home-infomation.vue'
import CustomerSlider from '@/components/home-layout/customer-slider.vue'
import TopColumnSlider from '@/components/home-layout/top-column-slider.vue'
import BottomColumnSlider from '@/components/home-layout/bottom-column-slider.vue'

export default {
  components: {
    HomeBanner,
    HomeInfomation,
    CustomerSlider,
    TopColumnSlider,
    BottomColumnSlider
  },
  computed: {
    getBannerByName () {
      return this.$store.getters['media/getBannerByName']
    },
    aboutTitle () {
      if (this.$store.state.lang === 'vn') return 'KIM CHỈ NAM CHO SỰ PHÁT TRIỂN'
      else return 'Guiding Principle For Development'
    },
    homePictures () {
      return this.$store.getters['news/getHomeMainNews']
    },
    getHorizontalData () {
      return this.$store.getters['layout/getHorizontalData']
    }
  },
  methods: {
    cacheBuster (url) {
      return `${url}?cacheBuster=${new Date().getTime()}`
    },
    async getNewestLayoutData () {
      await this.$store.dispatch('layout/getLayoutAdjData')
    }
  },
  created () {
    this.getNewestLayoutData()
  }
}
</script>

<style scoped>
  .home-section {
    padding: 0 170px;
  }

  .columns {
    display: flex;
    flex-direction: row;
    gap: 50px;
  }

  .cl1 {
    flex: 1;
  }

  .cl1 .about {
    background: url(../../assets/new-image/bg-home.png);
    padding: 20px 40px;
  }

  .cl1 h2 {
    color: #006884;
    text-align: center;
    margin: 10px 0px;
    font-weight: 700;
    font-size: 30px;
  }

  .cl1 img {
    max-width: 100%;
    margin: 20px 0px;
  }

  .cl2 {
    width: 300px;
    position: relative;
  }

  .sticky-cl {
    position: sticky;
    top: 0;
  }

  .cl2 img {
    max-width: 100%;
    object-fit: cover;
  }

  .main-news img {
    width: 100%;
    object-fit: cover;
  }

  @media (max-width: 1356px) {
    .home-section {
      padding: 0px 100px;
    }

    .cl2 {
      width: 250px;
    }
  }

  @media (max-width: 1135px) {
    .cl2 {
      display: none;
    }
  }

  @media (max-width: 1080px) {
    .home-section {
      padding: 0px 50px;
    }
  }

  @media (max-width: 720px) {
    .home-section {
      padding: 0px 20px;
    }

    .cl1 h2 {
      font-size: 22px;
    }
  }

  @media (max-width: 485px) {
    .cl1 .about {
      padding: 10px;
    }
  }

  @media (max-width: 400px) {
    .cl1 h2 {
      font-size: 16px;
    }

    .cl1 img {
      margin: 10px 0;
    }
  }

</style>
